import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faCog, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import './Header.scss';
import { useState } from 'react';
import { Box, Drawer } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../stores/globalStore';
import UserMenu from '../UserMenu/UserMenu';
import LangSelector from '../Lang/Lang';

export default function Header() {
  const isLogged = useSelector((state: RootState) => state.authentication.isLogged);
  const connectedUser = useSelector((state: RootState) => state.authentication.connectedUser);

  const navigate = useNavigate();

  const [drawerState, setDrawerState] = useState(false);

  const toggleDrawer = () => {
    setDrawerState(!drawerState);
  };

  const navigateToHome = () => {
    navigate('/');
  };

  const navigateToConfiguration = () => {
    navigate('/configuration/users');
  };

  const closeDrawer = () => {
    setDrawerState(false);
  };

  return (
    <>
      <header>
        <div className="title" onClick={navigateToHome} role="link" tabIndex={0} aria-hidden="true">
          <FontAwesomeIcon className="chartIcon" icon={faChartLine} />
          <span>Monitoring</span>
        </div>
        <div className="menus">
          <LangSelector />
          {isLogged && connectedUser.role === 'admin' && <FontAwesomeIcon className="settings pointer" icon={faCog} onClick={navigateToConfiguration} />}
          {isLogged && <FontAwesomeIcon className="pointer" icon={faUserCircle} onClick={toggleDrawer} />}
        </div>
      </header>

      <Drawer open={drawerState} anchor="right" onClose={toggleDrawer}>
        <Box sx={{ width: 300 }}>
          <UserMenu closeDrawer={closeDrawer} />
        </Box>
      </Drawer>
    </>

  );
}
